import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import Loader from '../../global/Loader'
import { useNavigate, useParams } from 'react-router-dom'
// import MiniHeader from '../../components/global/MiniHeader'
import Footer from '../../components/global/Footer'
import NoData from '../../components/NoData'
import { errorMessage } from '../../constants/errorMessage'
import { endParking } from '../../redux/actions/transientAction'
import { connect } from 'react-redux'
import ConfirmationModal from '../../global/ConfirmationModal'
import UpperHeader from '../../components/global/UpperHeader'
import ClockTimer from '../../components/global/ClockTimer'
import StartEndDate from '../../components/global/StartEndDate'
import AmountPaid from '../../components/global/AmountPaid'
import QRCodeComp from '../../components/global/QRCode'
import ExtendEndButton from '../../components/global/ExtendEndButton'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import PromoCode from '../../components/global/PromoCode'
import { getTicketDetails } from '../../redux/actions/ReceiptsAction'
// import { getConfigDetails } from '../../services/config'
import URL from '../../constants/urls'
import { Row } from 'react-bootstrap'
import { getBreakUpDetails, isPromoValidateButton, isZeroAmount, formatDecimal } from '../../utils/helper'
import { getConfigDetails } from '../../../../services/config'
// import {phoneMasker, formatDecimal} from '../../utils/helper'

function PaymentResponse(props) {
  const { dispatch, notify, loader } = props
  const [faciltyData, setFaciltyData] = useState(EMPTY_OBJECT)
  const [paymentData, setPaymentData] = useState(EMPTY_OBJECT)
  const [isDisplayDetails, setIsDisplayDetails] = useState(false)
  const [isEndingParking, setIsEndingParking] = useState(false)
  // const [isCouponApplied, setIsCouponApplied] = useState(false)

  const { partner } = useParams()

  // confirmation modal 
  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)

  // 
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  useEffect(() => {
    const Details = JSON?.parse(localStorage?.getItem('paymentRecipt'))
    const faclityDetails = JSON?.parse(localStorage?.getItem('faclityData'))
    setFaciltyData(faclityDetails)

    if (!Details || !Details?.ticket_number) {
      const pushBack = JSON.parse(localStorage.getItem('history'))
      navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
    } else {

      const payload = {
        'ticket': Details?.ticket_number,
        'phone': '',
        'cardLast4': '',
        'cardExpiry': '',
        'license_plate': '',
        'partner_id': getConfigDetails()?.PARTNER_ID,
      }
      dispatch(getTicketDetails(payload)).then((res) => {
        if (res?.status === 201 || res?.status === 200) {
          if (res?.data && res?.data != null) {
            // notify('success', 'T successfully')
            setPaymentData(res?.data)
            localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))

            // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(3))
          } else {
            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          }
        } else {
          // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        }
      }).catch(() => {
        notify('error', errorMessage?.somethingWentWrong)
      })
    }





    // const faclityDetails = JSON?.parse(localStorage?.getItem('faclityData'))
    // // const isCouponApplied = localStorage?.getItem('isCouponApplied')
    // // setIsCouponApplied(isCouponApplied)
    // const Details = JSON?.parse(localStorage?.getItem('paymentRecipt'))
    // // let listItem = [{ 'headerName': 'Parking Amount', 'val': `$${Details.base_amount ? Details.base_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${Details.tax_fee ? Details.tax_fee : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${Details.processing_fee ? Details.processing_fee : '0.00'}` }]
    // // if (Details?.discount_amount && Details?.discount_amount != '') {




    // const daysHoursLength = convertHoursToDaysMinutes(Number(Details?.length))
    // setHoursToDays(daysHoursLength)
  }, [EMPTY_ARRAY])



  // modal confirmation

  const handleConfimationModal = () => {
    setIsConfimationModalOpen(!isConfimationModalOpen)
  }


  const handleValidateTicket = (paymentData) => {
    if (paymentData?.paid_date) {
      notify('error', 'This ticket is already validated.')
    } else {
      navigate(`/${partner}${URL?.SCAN_VALIDATE}`, { state: { redirectUrl: `/${partner}/paymentResponse` } })
    }
  }

  const handleExtend = () => {
    navigate(`/${partner}/extend/${paymentData?.ticket_number}`)
  }
  const handleEndParking = () => {
    const pageHistory = JSON.parse(localStorage.getItem('history'))
    setIsConfimationModalOpen(!isConfimationModalOpen)
    setIsEndingParking(true)
    dispatch(endParking(paymentData?.ticket_number)).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        if (res?.data && res?.data != null) {
          localStorage.removeItem('paymentRecipt')
          localStorage.removeItem('ExtendData')
          notify('success', 'Thank you for parking with us. Please visit us again')
          setPaymentData(res?.data)
          setTimeout(() => {
            const pushBack = JSON.parse(localStorage.getItem('history'))
            navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            setIsEndingParking(false)
          }, 3000)

        } else {
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        }
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        setTimeout(() => {
          if (pageHistory?.route) {
            navigate(`/${partner}/${pageHistory?.route}/${pageHistory?.facility}`)
          } else {
            navigate(`/${partner}`)
          }
        }, 2000)
      }
    }).catch(() => {
      notify('error', errorMessage?.somethingWentWrong)
    })
  }

  return (

    (isEndingParking) ? <div className='main d-flex align-items-center justify-content-center'><Loader /></div> : <div className='PaveConfirmation main'>
      {/* <MiniHeader isDisplayBack title={'CURRENT PARKING SESSION'} /> */}
      {/* <h4 className='headerParking my-3 text-info'>Confirmation</h4> */}
      {(partner) ?
        paymentData?.ticket_number ? <div>
          <UpperHeader faciltyData={paymentData} totalHoursLength={paymentData?.length ? paymentData?.length : formatDecimal(0)} isDirection screen='payment' paymentData={paymentData} />

          <StartEndDate paymentData={paymentData} />

          <QRCodeComp paymentData={paymentData} isLicensePlate isMessage />

          {/* {isCouponApplied == 'false' && <PromoCode  */}
          {((partner !== 'intrapark') && isPromoValidateButton(faciltyData, ['1', '3'])) &&
            <PromoCode
              isTicketApply
              notify={notify}
              setPaymentData={setPaymentData}
              screen='paymentResponse'
              ticketDetails={paymentData}
            />
          }
          {/* {(priceGreaterOrNot(paymentData)) && <p className='text-primary fw-semibold py-3 px-2 mx-3 mb-2 bg-opacity-10 custom-dashed-border' >Price Breakdown</p>} */}
          <div className="container pt-3 pb-5 overflow-hidden">

            <div className={`${getBreakUpDetails(paymentData)?.length > 0 && (!loader) ? '' : 'normalTicket'} card shadow rounded-lg receiptCard`}>
              <PaymentBreakUpDetails
                className="py-2 d-flex"
                paymentData={paymentData}
                sectionKey={(!isZeroAmount(paymentData?.payable_amount) && paymentData?.payable_amount) ? '' : 'paymantResponse'}
                isDisplayDetails={true}
                setIsDisplayDetails={setIsDisplayDetails}
                screen="paymentResponse"
              />
              <div className="card-footer">
                <AmountPaid
                  className="py-2 pb-3 px-2"
                  paymentData={paymentData}
                  paybleText="Amount Paid"
                  sectionKey={(!isZeroAmount(paymentData?.payable_amount) && paymentData?.payable_amount) ? '' : 'paymantResponse'}
                  hideTaxIncluded={(paymentData?.payable_amount > 0 && (((paymentData?.tax_fee && !isZeroAmount(paymentData?.tax_fee)) || (paymentData?.tax_rate && !isZeroAmount(paymentData?.tax_rate))))) ? false : true}
                  setIsDisplayDetails={setIsDisplayDetails}
                  isInfo
                  cardInside
                />
              </div>
            </div>
          </div>
          <ClockTimer screen={'payment'} facilityData={faciltyData} />
          <Row className='m-auto justify-content-center'>
            {(isPromoValidateButton(faciltyData, ['2', '3']) && (!paymentData.reservation_id || paymentData.reservation_id === null) && (!paymentData.paid_date)) &&
              <div className='mb-4 col-sm-12 col-md-4'>
                <button
                  type="button"
                  className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'
                  onClick={() => handleValidateTicket(paymentData)}
                >
                  Validate Ticket
                </button>
              </div>}
            <ExtendEndButton
              handleEndParking={handleConfimationModal}
              handleExtend={handleExtend}
              screen='payment'
              isEndParking
              syncWithBtns
            />
          </Row>
        </div> : <Loader />
        : <NoData message={errorMessage?.invalidPartner} />}
      <PaymentBreakUpDetails
        className="my-2 "
        paymentData={paymentData}
        sectionKey={(!isZeroAmount(paymentData?.payable_amount) && paymentData?.payable_amount) ? '' : 'paymantResponse'}
        isDisplayDetails={isDisplayDetails}
        setIsDisplayDetails={setIsDisplayDetails}
      />

      <Footer />
      <ConfirmationModal
        isConfimationModalOpen={isConfimationModalOpen}
        setIsConfimationModalOpen={setIsConfimationModalOpen}
        finalAction={handleEndParking}
      />
    </div>
  )
}

PaymentResponse.propTypes = {
  dispatch: PropTypes.func,
  isFetching: PropTypes.bool,
  loader: PropTypes.bool,
  notify: PropTypes.func,
}

PaymentResponse.defaulProps = {
  dispatch: noop,
  isFetching: false,
  loader: false,
  notify: noop,
}

function mapStateToProps({ transientReducer, ReceiptsReducer }) {
  return {
    // loader: transientReducer?.loader,
    isFetching: transientReducer?.isFetching,
    loader: ReceiptsReducer?.loader,
  }
}

export default connect(mapStateToProps)(PaymentResponse)
